import {Header} from '../../components/Header';
import {Footer} from '../../components/Footer';

const iubendaTermsScript = `<a href="https://www.iubenda.com/terms-and-conditions/92515433" class="iubenda-white iubenda-noiframe iubenda-embed iubenda-noiframe iub-body-embed" title="Terms and Conditions">Terms and Conditions</a><script type="text/javascript">(function (w,d) {var loader = function () {var s = d.createElement("script"), tag = d.getElementsByTagName("script")[0]; s.src="https://cdn.iubenda.com/iubenda.js"; tag.parentNode.insertBefore(s,tag);}; if(w.addEventListener){w.addEventListener("load", loader, false);}else if(w.attachEvent){w.attachEvent("onload", loader);}else{w.onload = loader;}})(window, document);</script>`;

export default function TermsAndConditionsPage() {
  return (
    <>
      <Header />
      <div dangerouslySetInnerHTML={{__html: iubendaTermsScript}} />

      <Footer />
    </>
  );
}
